import { render, staticRenderFns } from "./ImportFileUrls.vue?vue&type=template&id=b08c9148&scoped=true&"
import script from "./ImportFileUrls.vue?vue&type=script&lang=js&"
export * from "./ImportFileUrls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08c9148",
  null
  
)

export default component.exports